import * as React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useI18n } from "@/i18n/I18nProvider";
import { toArabicNumber } from "@/utils/general-functions";

const NAVY = "#0B2A4A";
const ORANGE = "#ED7A11";
const YELLOW = "#F7DE1A";

// ثوابت برا الكومبوننت عشان ما تتعملش كل render
const RIBBON_W = { xs: 60, sm: 90, md: 130 };
const RIBBON_H = { xs: 70, sm: 140, md: 180 };

export function StepCard({
  number,
  title,
  titleType,
  Icon,
  pageTitle,
  showIcon = false,
  showStepLabel = false,
}) {
  const { locale } = useI18n();
  const isRTL = locale === "ar";

  const displayTitle = React.useMemo(() => {
    return (title || "").replaceAll("{{branch}}", pageTitle || "");
  }, [title, pageTitle]);

  return (
    <Stack
      direction="row"
      alignItems={{ xs: "center", md: "center" }}
      spacing={2}
      mb={{ xs: 3, sm: 4, md: 6 }}
    >
      <Box
        sx={{
          position: "relative",
          minWidth: RIBBON_W,
          height: RIBBON_H,
        }}
      >
        <Box
          aria-hidden
          sx={{
            position: "absolute",
            inset: 0,
            background: YELLOW,
            transform:
              isRTL && showStepLabel ? "skewX(15deg)" : "skewX(-15deg)",
            zIndex: 1,
            marginInlineStart: { xs: 2, md: 5 },
          }}
        />

        <Typography
          sx={{
            position: "absolute",
            top: showStepLabel ? { xs: 5, md: 20 } : { xs: -20, md: -30 },
            left: showStepLabel
              ? { xs: 15, md: isRTL ? 90 : 40 }
              : { xs: 40, md: isRTL ? 150 : 110 },
            fontWeight: 700,
            fontSize: { xs: 30, sm: 40, md: 80 },
            color: ORANGE,
            zIndex: 2,
          }}
        >
          {isRTL ? toArabicNumber(number) : parseInt(number)}{" "}
        </Typography>

        {/* icon*/}
        {showIcon && Icon && (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: isRTL ? "20%" : "20%",
              transform: isRTL
                ? "translate(50%, -20%)"
                : "translate(-50%, -20%)",
              color: NAVY,
              zIndex: 2,
              "& img": {
                width: "100%",
                height: "auto",
              },
            }}
          >
            <img src={Icon} alt="service icon" />
          </Box>
        )}
      </Box>

      {/* title */}
      <Typography
        component={titleType}
        sx={{
          color: NAVY,
          fontSize: { xs: 13, sm: 16, md: 20 },
          fontWeight: 700,
          lineHeight: 1.2,
          position: "relative",
          top: showStepLabel ? { xs: "-3px", md: "9px", xl: "-8px" } : "auto",
          textAlign: isRTL ? "right" : "left",
          maxWidth: { xs: 140, sm: 220, md: 260 },
          zIndex: 2,
        }}
      >
        {displayTitle}
      </Typography>
    </Stack>
  );
}
